import script from "./TokenSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./TokenSettings.vue?vue&type=script&setup=true&lang=js"

import "./TokenSettings.vue?vue&type=style&index=0&id=b97843be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b97843be"]])

export default __exports__